import { createFileRoute } from '@tanstack/react-router'
import { HttpStatusPage, httpStatusHead } from '@/components/http-status-page'
import type { HttpStatusData } from '@/components/http-status-page'

const data: HttpStatusData = {
  code: 410,
  name: 'Gone',
  description:
    'The resource existed before but has been permanently removed and will not return. Unlike 404, a 410 explicitly tells clients and search engines to stop requesting this URL.',
  causes: [
    'The resource was intentionally deleted and the server wants to communicate that it is permanently gone, not just missing.',
    'An API version was retired and the server returns 410 to signal that clients must migrate to the new version.',
    'Content was removed for legal, compliance, or business reasons and will not be restored.',
  ],
  fixes: [
    'Remove all links and references to the gone URL. Update bookmarks and any integrations that use this endpoint.',
    'If you are an API consumer, check the API documentation for the replacement endpoint or the new version.',
    'For SEO, 410 is better than 404 for removed content — search engines de-index the URL faster. If you removed content intentionally, 410 is the right choice.',
  ],
  monitoringTip:
    'If a monitored URL returns 410, Uptrack detects it within 30 seconds and alerts you once several locations confirm it. This is useful for catching unintended deletions — if a critical endpoint returns 410 when it should not, you will know quickly.',
}

export const Route = createFileRoute('/_site/http/410')({
  component: () => <HttpStatusPage data={data} />,
  head: () => httpStatusHead(data),
})
